var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-content", attrs: { id: "planning-list" } },
    [
      _c("Titlebar", { attrs: { incrustation: "fa-calendar" } }, [
        _c("h1", [_vm._v(_vm._s(_vm.$t("planning.titles.list")))]),
      ]),
      _vm._v(" "),
      _c("div", {
        staticClass: "alert alert-info mb-4",
        domProps: { innerHTML: _vm._s(_vm.$t("planning.descriptions.list")) },
      }),
      _vm._v(" "),
      _c(
        "UiCard",
        [
          _c("SuperTable", {
            ref: "tablePlannings",
            attrs: {
              tableColumns: _vm.tableColumns,
              tableData: _vm.tableData ? _vm.tableData : [],
              loading: !_vm.tableData,
            },
            on: {
              sort: _vm.handleSort,
              filter: _vm.handleFilter,
              delete: _vm.handleDelete,
              copy: _vm.handleCopy,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("Toolbar", [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col" },
            [
              _c(
                "Btn",
                {
                  directives: [
                    {
                      name: "can",
                      rawName: "v-can",
                      value: "beepiz-add-profiles",
                      expression: "'beepiz-add-profiles'",
                    },
                  ],
                  class: "default",
                },
                [
                  _c(
                    "router-link",
                    { attrs: { to: { name: "PlanningNew" } } },
                    [
                      _c("i", { staticClass: "fa fa-plus" }),
                      _c("span", [_vm._v(_vm._s(_vm.$t("planning.btns.add")))]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col center" },
            [
              _c("Pagination", {
                ref: "pagination",
                on: { change: _vm.handlePagination },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col" }),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }